import React, { useEffect, useRef, useState } from "react";
import ListItem from "@mui/material/ListItem";
import { ListItemText } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { makeStyles } from "tss-react/mui";
import formatIngredient from "../../util/ingredient-helper";

const useStyles = makeStyles()((theme) => ({
  listItem: {
    paddingRight: "64px",
    maxHeight: "60px",
    transition: "all 500ms",
    overflow: "hidden",
  },

  checkedItem: {
    textDecoration: "line-through",
  },

  checkedAnimate: {
    maxHeight: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },

  editButton: {
    padding: "5px 4px",
    color: theme.palette.primary.main,
  },

  deleteButton: {
    padding: "5px 4px",
    color: theme.palette.error.main,
  },

  actions: {
    width: "64px",
    right: "6px;",
  },
}));

export default function IngredientListItem({
  ingredient,
  updateIngredient,
  removeIngredient,
  multiplier = 1,
  editMode = false,
  showCheckBoxes = false,
  handleCheck = null,
}: any) {
  const canCheck = showCheckBoxes && !editMode;
  const { classes, cx } = useStyles();
  const liRef = useRef(null);
  const [checked, setChecked] = useState(!!ingredient.checked);

  useEffect(() => {
    liRef.current.classList.remove(classes.checkedAnimate);
    setChecked(ingredient.checked);
  }, [ingredient.checked, liRef, classes.checkedAnimate]);

  function onCheck() {
    setChecked(!checked);
    if (liRef) {
      liRef.current.classList.add(classes.checkedAnimate);
    }
    setTimeout(() => {
      handleCheck();
    }, 500);
  }

  return (
    <ListItem
      ref={liRef}
      className={classes.listItem}
      onClick={canCheck ? () => onCheck() : null}
      divider
    >
      {canCheck && (
        <Checkbox
          checked={checked || false}
          onChange={() => onCheck()}
          inputProps={{ "aria-label": "ingredient checkbox" }}
        />
      )}
      <ListItemText
        secondaryTypographyProps={{
          className: classes.checkedItem,
        }}
        classes={{
          primary: cx("MuiListItemText-primary", {
            [classes.checkedItem]: !editMode && checked,
          }),
        }}
        primary={formatIngredient(ingredient, multiplier)}
      />
      {editMode && (
        <ListItemSecondaryAction className={classes.actions}>
          <IconButton
            className={classes.editButton}
            onClick={() => updateIngredient()}
            aria-label="edit-ingredient"
          >
            <EditIcon />
          </IconButton>
          <IconButton
            className={classes.deleteButton}
            onClick={() => removeIngredient()}
            aria-label="remove-ingredient"
          >
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
}
